module.exports = __webpack_public_path__ + "img/03-2-2销售管理.08c11e97.svg";